module.exports = __webpack_public_path__ + "static/Redbubble-215240173968c7d525a8b0366503a35e.png";